import { z } from 'zod';

// Base Types
export interface Category {
  id: number;
  name: string;
  parent_id: number | null;
  provider_id: number;
  version_id: number;
  display_order: number;
  price: number | null;
  description: string | null;
  is_addon: boolean | null;
  channels_count?: number;
  created_at: string;
  updated_at?: string;
}

// API Input Types
export interface CreateCategoryParams {
  name: string;
  parentId: number | null;
  displayOrder?: number;
  providerId: number;
  versionId: number;
  price?: number | null;
  description?: string | null;
  isAddon?: boolean | null;
}

export interface UpdateCategoryParams {
  id: number;
  name: string;
  parentId: number | null;
  displayOrder: number;
  providerId: number;  // Used for query invalidation only
  versionId: number;   // Used for query invalidation only
  price?: number | null;
  description?: string | null;
  isAddon?: boolean | null;
}

export interface DeleteCategoryParams {
  categoryIds: number[];
  providerId: number;
  versionId: number;
  price?: number | null;
  description?: string | null;
}

// Form Types
export const categorySchema = z.object({
  name: z.string().min(1, 'Category name is required'),
  parentId: z.number().nullable(),
  displayOrder: z.number().optional(),
  price: z.number().nullable().optional(),
  description: z.string().optional(),
  isAddon: z.boolean().nullable().optional()
});

export type CategoryFormData = z.infer<typeof categorySchema>;

export interface CategoryFormValues extends CategoryFormData {
  id?: number;
}

// Other Types
export interface CategoryHierarchyItem extends Category {
  level: number;
  hasChildren: boolean;
}

export type UpdateCategoryOrderParams = {
  providerId: number;
  versionId: number;
  updates: Array<{
    id: number;
    display_order: number;
    price?: number | null;
    description?: string | null;
  }>;
}

export interface CategoryWithRelations extends Category {
  channels?: { count: number }[];
  children?: CategoryWithRelations[];
  parent_name?: string;
}